import React, { useEffect, useState } from "react";
import { Tab, Tabs, TabPanel } from "react-tabs";
import { useForm } from "react-hook-form";
import { TableLoader } from "../../../Common/ShimmerLoader";
import { GetAllNotClearedCollectionTransaction, GVPClearanceDateReports, GVPClearanceInnerDownload, HotspotClearanceInnerDownload } from "../../../Apis/gvpClearanceReportApi"; // Import your API function
import { useNavigate } from "react-router-dom";
import CustomDataTable from "../../../Common/ReportTable/ReportTable";
import ExcelJS from 'exceljs';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { AllVehicleTypeDetails } from "../../../Apis/vehicleApi";
import isGHMC, { getCurrentDateTime, getStartOfCurrentDate } from "../../../Common/helper/helpar";

function GVPsClearanceDateReport() {

  const { handleSubmit, formState: { errors } } = useForm();
  const isProd = isGHMC();

  const currentDateWithStartTime = getStartOfCurrentDate();
  const currentDateTime = getCurrentDateTime();

  const [formInput, setFormInput] = useState({
    fromDate: currentDateWithStartTime,
    toDate: currentDateTime,
    vehicleTypeId: "",
  });

  const [isOptionsLoading, setIsOptionsLoading] = useState(false);
  const [reports, setReports] = useState([]);
  const [error, setError] = useState(null);
  const [vehicleType, setVehicleType] = useState([]);

  const fetchVehicleTypeData = async () => {
    try {
      const data = await AllVehicleTypeDetails();
      setVehicleType(data);
    } catch (error) {
      console.error("Error fetching owner Data by ID:", error);
    }
  };

  useEffect(() => {
    fetchVehicleTypeData()
  }, [])

  // Function to handle form submission
  const searchZoneReport = async () => {
    setIsOptionsLoading(true);
    setError(null);

    try {
      const response = await GVPClearanceDateReports(formInput.fromDate, formInput.toDate, formInput.vehicleTypeId);
      setReports(response); // Adjust based on the structure of your response
    } catch (err) {
      setError("An error occurred while fetching the report. Please try again.");
      console.error(err);
    } finally {
      setIsOptionsLoading(false);
    }
  };

  const handleKeyDown = (event, callback) => {
    if (event.key === "Enter" && event.shiftKey === false) {
      event.preventDefault();
    }
  };

  useEffect(() => {
    searchZoneReport()
  }, [])

  function convertDate(dateString) {
    const [day, month, year] = dateString.split("-");
    return `${year}-${month}-${day}`;
  }

  const gvpDateReports = [
    {
      name: 'S.No',
      selector: (row) => row['slno'],
      sortable: true,
      format: (row, rowIndex) => rowIndex + 1,
    },
    {
      name: 'Date',
      selector: (row) => row['dateframe'] || "N/A",
      // onclick:handleDateClick(),
      sortable: true,
    },
    {
      name: <>Cleared GVPs<br />Points</>,
      selector: (row) => row['clearedCp'],
      sortable: true,
      cell: (row) => (
        <>
          <span style={{ color: row.clearedCp !== 0 && "blue", cursor: row.clearedCp !== 0 && "pointer" }}
            onClick={() => {
              const column = {
                fromDate: convertDate(row['dateframe'])+"T00:00",
                toDate: convertDate(row['dateframe'])+"T23:59",
                vehicleTypeId: formInput.vehicleTypeId
              };
              row.clearedCp !== 0 && handleDownloadExcelClearedGVPs(column);
            }}>{row.clearedCp}
          </span>
        </>
      ),
    },
    {
      name: 'Cleared Hotspots',
      selector: (row) => row['clearedHotspot'],
      sortable: true,
      cell: (row) => (
        <>
          <span style={{ color: row.clearedHotspot !== 0 && "blue", cursor: row.clearedHotspot !== 0 && "pointer" }}
            onClick={() => {
              const column = {
                fromDate: convertDate(row['dateframe'])+"T00:00",
                toDate: convertDate(row['dateframe'])+"T23:59",
                vehicleTypeId: formInput.vehicleTypeId
              };
              row.clearedHotspot !== 0 && handleDownloadExcelClearedHotspots(column);
            }}>{row.clearedHotspot}
          </span>
        </>
      ),
    },
    {
      name: <>Not Cleared<br />GVPs Points</>,
      selector: (row) => row['notClearedCp'],
      sortable: true,
      cell: (row) => (
        <span
          style={{ color: row.notClearedCp !== 0 ? "blue" : "black", cursor: row.notClearedCp !== 0 ? "pointer" : "default" }}
          onClick={() => {
            if (row.notClearedCp !== 0) {
              const column = {
                date: row.dateframe,
                vehicleTypeId: formInput.vehicleTypeId,
              };
              row.notClearedCp !== 0 && handleDownloadExcelNotClearedGvp(column);
            }
          }}
        >
          {row.notClearedCp}
        </span>
      ),
    },
    {
      name: 'Total Cleared',
      selector: (row) => row['totalCleared'],
      sortable: true,
    },

  ]
  function convertDate(dateString) {
    const [day, month, year] = dateString.split("-");
    return `${year}-${month}-${day}`;
  }

  const handleDownloadExcelClearedGVPs = async (colum) => {
    try {
      const fromDate = colum.fromDate;  // Set to null if not provided
      const toDate = colum.toDate;
      const vehicleTypeId = colum.vehicleTypeId;

      const response = await GVPClearanceInnerDownload(fromDate, toDate, vehicleTypeId);
      const data = response;

      if (data && data.length > 0) {
        const formattedData = data.map((item, index) => ({
          'Sl.No': index + 1,
          'Zone': item.zoneName,
          'Circle': item.circleName,
          'Ward': item.wardName,
          'GVP Point Name': item.gvpPointName,
          'Cleaned By': item.cleanedBy,
          'Vehicle Type': item.vehicleType,
          'Owner Type': item.ownerTypeName,
          'Vehicle Capacity': item.vehicleCapacity,
          'Mobile': item.mobile,
          'Time': item.time
        }));

        // Convert data to Excel worksheet
        const worksheet = XLSX.utils.json_to_sheet(formattedData);

        // Define column widths
        const columnWidths = [
          { wpx: 50 },  // Sl.No
          { wpx: 100 }, // Zone
          { wpx: 100 }, // Circle
          { wpx: 100 }, // Ward
          { wpx: 100 }, // GVP Point Name
          { wpx: 150 }, // Cleaned By
          { wpx: 120 }, // Vehicle Type
          { wpx: 120 }, // Vehicle Type
          { wpx: 120 }, // Vehicle Capacity
          { wpx: 160 }, // Mobile
          { wpx: 120 }, // Time
        ];

        // Apply the column widths
        worksheet['!cols'] = columnWidths;

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'GVP Clearance Report');

        // Write the Excel file and trigger download
        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
        saveAs(blob, `GVP_Clearance_Report.xlsx`);
      } else {
        console.error('No data available to download.');
      }
    } catch (error) {
      console.error('Error downloading Excel file:', error);
    }
  };

  const handleDownloadExcelNotClearedGvp = async (colum) => {
    try {
      // Format the date to YYYY-MM-DD
      const formattedDate = convertDate(colum.date); // Convert DD-MM-YYYY to YYYY-MM-DD
      const vehicleTypeId = colum.vehicleTypeId || ""; // Fallback to empty string if undefined
  
      // Log parameters for debugging
      console.log("Not Cleared GVP API Call Parameters:", { date: formattedDate, vehicleTypeId });
  
      // Call the API with formatted date and vehicleTypeId
      const response = await GetAllNotClearedCollectionTransaction({date:formattedDate, vehicleTypeId});
      console.log("Not Cleared GVP API Response:", response);
  
      const data = response?.data || response; // Handle different response structures
  
      if (data && data.length > 0) {
        // Map data to Excel format
        const formattedData = data.map((item, index) => ({
          'S.No': index + 1,
          'Zone': item.zoneName ?? "N/A",
          'Circle': item.circleName ?? "N/A",
          'Ward': item.wardName ?? "N/A",
          'Collection Point Code': item.collectionPointCode ?? "N/A",
          'Collection Point Type': item.collectionPointTypeName ?? "N/A",
          'Collection Point Name': item.collectionPointName ?? "N/A",
          'Latitude': item.latitude ?? "N/A",
          'Longitude': item.longitude ?? "N/A",
          
        }));
  
        // Convert data to Excel worksheet
        const worksheet = XLSX.utils.json_to_sheet(formattedData);
  
        // Define column widths
        const columnWidths = [
          { wpx: 50 },  // Sl.No
          { wpx: 100 }, // Zone
          { wpx: 100 }, // Circle
          { wpx: 100 }, // Ward
          { wpx: 150 }, // GVP Point Name
          { wpx: 150 }, // Cleaned By
          { wpx: 120 }, // Vehicle Type
        ];
  
        // Apply column widths
        worksheet['!cols'] = columnWidths;
  
        // Create workbook and append worksheet
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Not Cleared GVP Report');
  
        // Generate and download the Excel file
        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
        saveAs(blob, `NotClearedGVP_Report_${formattedDate}.xlsx`);
  
        // toast.success("Excel file downloaded successfully!");
      } else {
        // toast.warn("No data available to download.");
        console.warn("No data returned from GetAllNotClearedCollectionTransaction:", response);
      }
    } catch (error) {
      // toast.error("Failed to download Excel file. Please try again.");
      console.error('Error downloading Not Cleared GVP Excel file:', error);
    }
  };





  const handleDownloadExcelClearedHotspots = async (colum) => {

    try {
      const fromDate = colum.fromDate;  // Set to null if not provided
      const toDate = colum.toDate;
      const vehicleTypeId = colum.vehicleTypeId;

      const response = await HotspotClearanceInnerDownload(fromDate, toDate, vehicleTypeId);
      const data = response;
      // console.log(data,'responsedataa')
      if (data && data.length > 0) {
        const formattedData = data.map((item, index) => ({
          'Sl.No': index + 1,
          'Zone': item.zoneName,
          'Circle': item.circleName,
          'Ward': item.wardName,
          'GVP Point Name': item.gvpPointName,
          'Cleaned By': item.cleanedBy,
          'Vehicle Type': item.vehicleType,
          'Vehicle Capacity': item.vehicleCapacity,
          'Mobile': item.mobile,
          'Time': item.time
        }));

        // Convert data to Excel worksheet
        const worksheet = XLSX.utils.json_to_sheet(formattedData);

        // Define column widths (use `wpx` for pixel values)
        const columnWidths = [
          { wpx: 50 },  // Sl.No
          { wpx: 100 }, // Zone
          { wpx: 100 }, // Circle
          { wpx: 100 }, // Ward
          { wpx: 100 }, // GVP Point Name
          { wpx: 150 }, // Cleaned By
          { wpx: 120 }, // Vehicle Type
          { wpx: 120 }, // Vehicle Capacity
          { wpx: 160 }, // Mobile
          { wpx: 120 }, // Time
        ];

        // Apply column widths to the worksheet
        worksheet['!cols'] = columnWidths;

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'GVP Clearance Report');

        // Write the Excel file and trigger download
        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
        saveAs(blob, `Hotspot_Clearance_Report.xlsx`);
      } else {
        console.error('No data available to download.');
      }
    } catch (error) {
      console.error('Error downloading Excel file:', error);
    }
  };






  const downloadExcel = async () => {
    const currentDate = new Date();
    const formattedDate = `${currentDate.getDate()}-${currentDate.getMonth() + 1}-${currentDate.getFullYear()}`;
    const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;

    
    const formatDateTimeWithT = (datetimeStr) => {
      const [date, time] = datetimeStr.split("T");
      const [year, month, day] = date.split("-");
      return `${day}-${month}-${year}T${time}`;
    };
    
    const cumulativeHeadingReport = `GVPs Clearance Report from ${formatDateTimeWithT(formInput.fromDate)} to ${formatDateTimeWithT(formInput.toDate)}`;
    

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Report");

    const boldFont = { bold: true };

    const downloadDateTime = `Reported on: ${formattedDate} ${formattedTime}`;
    const dateTimeRow = worksheet.addRow(["", "", downloadDateTime, "", ""]);
    worksheet.mergeCells(1, 3, 1, 5);
    dateTimeRow.getCell(3).font = boldFont;
    dateTimeRow.getCell(3).alignment = { horizontal: "center" };

    const cumulativeHeadingRow = worksheet.addRow(["", "", cumulativeHeadingReport, "", ""]);
    worksheet.mergeCells(2, 3, 2, 5);
    cumulativeHeadingRow.getCell(3).font = boldFont;
    cumulativeHeadingRow.getCell(3).alignment = { horizontal: "center" };

    worksheet.addRow([""]);

    const tableHeaderRow = worksheet.addRow([
      "S.No",
      "Date",
      "Cleared GVPs Points",
      "Cleared Hotspots",
      "Not Cleared GVPs Points",
      "Total Cleared",
    ]);

    tableHeaderRow.eachCell({ includeEmpty: true }, (cell) => {
      cell.font = boldFont;
      cell.alignment = { horizontal: "left" };
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "F6B1B1" }
      };
    });

    reports.forEach((item, index) => {
      worksheet.addRow([
        index + 1,
        item.dateframe?? "N/A",
        item.clearedCp?? "N/A",
        item.clearedHotspot?? "N/A",
        item.notClearedCp?? "N/A",
        item.totalCleared?? "N/A",
      ]).eachCell({ includeEmpty: true }, (cell, colNumber) => {
        cell.alignment = { horizontal: "left" };
      });
    });

    worksheet.columns = [
      { width: 5 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 23 },
      { width: 20 },
    ];

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "GVPsClearanceReport.xlsx";
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <>
      <div style={{ width: "100%" }}>
        <div className="content">
          <div className="page-content">
            <h4 className="text-start mb-3">GVPs Clearance Report-(Date Range)</h4>
            <div className="page-header">
              <div className="card">
                <div className="card-body p-3">
                  {error && <div className="alert alert-danger">{error}</div>}
                  <div className="row align-items-center">
                    <div className="col-md-10">
                      <form
                        onSubmit={(e) => {
                          e.preventDefault();
                          searchZoneReport();
                        }}
                        onKeyDown={(e) => {
                          handleKeyDown(e, handleSubmit);
                        }}
                      >
                        <div className="row align-items-center" style={{ textAlign: "justify" }}>
                          <div className="col-md-3 ">
                            <label htmlFor="fromDate">From Date & Time</label>
                            <input
                              type="datetime-local"
                              name="fromDate"
                              value={formInput.fromDate}
                              style={inputStyle}
                              className="form-control"
                              max={formInput.toDate ? formInput.toDate : getStartOfCurrentDate()}
                              onChange={(e) => {
                                setFormInput({
                                  ...formInput,
                                  fromDate: e.target.value,
                                })
                                localStorage.setItem("GvpClearanceFromDate", e.target.value)
                              }}
                            />
                          </div>
                          <div className="col-md-3 ">
                            <label htmlFor="toDate">To Date & Time</label>
                            <input
                              type="datetime-local"
                              name="toDate"
                              value={formInput.toDate}
                              style={inputStyle}
                              className="form-control"
                              min={formInput.fromDate}
                              max={currentDateTime}
                              onChange={(e) => {
                                setFormInput({
                                  ...formInput,
                                  toDate: e.target.value,
                                })
                                localStorage.setItem("GvpClearanceToDate", e.target.value)
                              }}
                            />
                          </div>
                          <div className="col-md-3">
                            <label htmlFor="VehicleTypeId">Vehicle Type</label>
                            <select
                              className="form-select"
                              style={{ backgroundColor: "#fff" }}
                              name="vehicleTypeId"
                              value={formInput.vehicleTypeId}
                              id="vehicleTypeId"
                              // onChange={(e) => setVehicleTypeId(e.target.value)}
                              onChange={(e) => {
                                setFormInput({
                                  ...formInput,
                                  vehicleTypeId: e.target.value,
                                });
                                localStorage.setItem(
                                  "vehicleType",
                                  e.target.value
                                );
                              }}
                            >
                              <option value="">All</option>
                              {vehicleType
                                .filter((vehicle) => vehicle.isActive)
                                .map((vehicle) => (
                                  <option
                                    key={vehicle.vehicleTypeId}
                                    value={vehicle.vehicleTypeId}
                                  >
                                    {vehicle.vehicleTypeName}
                                  </option>
                                ))}
                            </select>
                          </div>
                          <div className="col-md-3 ">
                            <button
                              type="submit"
                              className={`btn mt-4 mr-2 ${isProd ? "search-ghmc" : "search-swm"}`}
                            >
                              Search
                            </button>
                            <button
                              type="reset"
                              className={`btn mt-4 ${isProd ? "search-ghmc" : "search-swm"}`}
                              onClick={() => {
                                setFormInput(
                                  {
                                    fromDate: currentDateWithStartTime,
                                    toDate: currentDateTime,
                                    vehicleTypeId: "",
                                  }
                                )
                              }}
                            >
                              Reset
                            </button>
                          </div>
                        </div>
                      </form>
                    </div>
                    <div className="col-md-2">
                      <div className="text-end">
                        <button
                          className="btn btn-excel ms-auto mt-4"
                          onClick={downloadExcel}
                        >
                          <i className="fa-solid fa-file-excel me-1 icon-container"></i> Excel
                        </button>
                      </div>
                    </div>
                  </div>

                  <div className="card mt-3">
                    <div className=" ">
                      <CustomDataTable data={reports} columns={gvpDateReports} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default GVPsClearanceDateReport;

const inputStyle = {
  border: "1px solid #E2E2E2",
  padding: "15px",
  borderRadius: "0px",
};